"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeCheck = void 0;
const TYPE_KEY = '@type';
class TypeCheck {
    constructor(typeName) {
        var _a;
        Object.defineProperty(this, 'typeName', {
            enumerable: false,
            configurable: false,
            value: typeName,
            writable: false
        });
        this.isType = this.isType.bind(this);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const check = this;
        this.clazz = (_a = class {
                constructor() {
                    check.assign(this);
                }
            },
            _a.isType = check.isType,
            _a);
        Object.freeze(this);
    }
    assign(object) {
        if (object[TYPE_KEY] && Array.isArray(object[TYPE_KEY])) {
            if (!object[TYPE_KEY].includes(this.typeName)) {
                object[TYPE_KEY].push(this.typeName);
            }
        }
        else {
            Object.defineProperty(object, TYPE_KEY, {
                value: [this.typeName],
                enumerable: false,
                configurable: false,
                writable: false
            });
        }
        return object;
    }
    isType(value) {
        // eslint-disable-next-line no-null/no-null
        return (typeof value === 'object' || typeof value === 'function') && value !== null && Array.isArray(value[TYPE_KEY]) && value[TYPE_KEY].includes(this.typeName);
    }
}
exports.TypeCheck = TypeCheck;
